import { defineStore } from 'pinia';
import type { Donation } from './types';

interface State {
  donations: Donation[];
  donationsCategories: string[];
}

export default defineStore('donation', {
  state: (): State => ({
    donations: [],
    donationsCategories: [],
  }),
});
